import {
    COORDINATES_CODE,
    NEAREST_NIO_HOUSE_CODE,
    NEAREST_CHARGING_PILE_CODE,
    NEAREST_EXCHANGE_STATION_CODE
} from '@/util/dmp/site-code';
import { mapState, mapActions } from 'vuex';
import { calcDistance } from '@/util/map.js';
import { getLocation } from '@/util/platform';

export default {
    data() {
        return {
            isRefreshingLocation: false,
            targetLocation: {} // 目标场所位置信息
        };
    },
    props: {
        isInit: {
            type: Boolean,
            default: false
        },
        isInitLocation: {
            type: Boolean,
            default: false
        },
        isInitializedLocation: {
            type: Boolean,
            default: false
        },
        distanceValid: {
            type: [String, Number],
            default: 3000
        },
        locationType: {
            type: Array,
            default: () => [
                COORDINATES_CODE,
                NEAREST_NIO_HOUSE_CODE,
                NEAREST_CHARGING_PILE_CODE,
                NEAREST_EXCHANGE_STATION_CODE
            ] // 位置类型
        },
        coordinates: {
            type: String,
            default: '' // 指定坐标 'lat,lng'
        },
        coordinatesName: {
            type: String,
            default: '活动位置' // 指定坐标名称
        },
        userPosition: {
            type: Object,
            default: () => ({})
        }
    },
    mounted() {},
    computed: {
        ...mapState('marketing/', [
            'campaignOption',
            'activityConfig',
            'pageConfig',
            'awardDetail'
        ]),
        isInitLocationPrivate: {
            get({ isInitLocation }) {
                return isInitLocation;
            },
            set(v) {
                this.$emit('update:isInitLocation', v);
            }
        },
        isInitializedLocationPrivate: {
            get({ isInitializedLocation }) {
                return isInitializedLocation;
            },
            set(v) {
                this.$emit('update:isInitializedLocation', v);
            }
        },
        userPositionPrivate: {
            get({ userPosition }) {
                return userPosition;
            },
            set(v) {
                this.$emit('update:userPosition', v);
            }
        },
        locationName() {
            const { short_name } = this.targetLocation || {};
            return short_name || '--';
        },
        locationNameFontSize() {
            return this.locationName.length > 14 ? 'small-font' : '';
        },
        locationCoordinates() {
            const { tencent_gps_coordinate } = this.targetLocation || {};
            if (!tencent_gps_coordinate) {
                return {};
            }

            const [lat, lng] = tencent_gps_coordinate.split(',');
            return { lat, lng };
        },
        distance() {
            return this.userPositionPrivate.distance;
        },
        distanceDisplay() {
            return this.getDistanceDisplay(this.distance, 2);
        },
        distanceValidDisplay() {
            return this.getDistanceDisplay(this.distanceValid, 'never');
        },
        isDistanceValid() {
            const { distance } = this.userPositionPrivate;
            return (
                distance !== undefined &&
                this.distanceValid &&
                distance <= this.distanceValid
            );
        }
    },
    methods: {
        ...mapActions('marketing/', ['getAwardCompTargetLocation']),
        async updateUserPosition(position) {
            // 获取场所位置
            if (position && position.lat) {
                try {
                    const extra_params = this.getLocationExtraParams({
                        latitude: position.lat,
                        longitude: position.lng
                    });
                    const targetLocation = await this.getAwardCompTargetLocation(
                        {
                            extra_params: JSON.stringify(extra_params),
                            location_type: this.locationType.join(',')
                        }
                    );
                    if (
                        targetLocation &&
                        targetLocation.data &&
                        targetLocation.data.length
                    ) {
                        this.targetLocation = targetLocation.data[0] || {};
                    } else {
                        this.targetLocation = {};
                    }
                } catch (error) {
                    console.log('getAwardCompTargetLocation error', error);
                    this.targetLocation = {};
                }
            }

            // 计算位置和用户之间距离
            const { lat, lng } = this.locationCoordinates || {};
            const { lat: latUser, lng: lngUser, city: cityName } =
                position || {}; // @TODO: app定位和wx定位没有city

            if (lat && lng && latUser && lngUser) {
                const distance = calcDistance(lat, lng, latUser, lngUser);

                this.userPositionPrivate = {
                    distance: distance,
                    lat: latUser,
                    lng: lngUser,
                    cityName
                };
            } else {
                this.userPositionPrivate = {
                    distance: undefined,
                    lat: latUser,
                    lng: lngUser,
                    cityName
                };
            }

            // 第一次获取用户位置信息回调后
            if (!this.isInitializedLocationPrivate) {
                this.isInitializedLocationPrivate = true;
            }

            // 稍微延迟一点
            setTimeout(() => {
                this.isRefreshingLocation = false;
            }, 300);
        },
        getLocationExtraParams(payload) {
            const types = this.locationType || [];

            return types.reduce(
                (pre, type) => {
                    const curr = this.getLocationPayloadByType(type);

                    // 换电站/充电桩 参数拼接
                    if (curr.resource_type) {
                        curr.resource_type = pre.resource_type
                            ? `${pre.resource_type}|${curr.resource_type}`
                            : curr.resource_type;
                    }

                    return { ...pre, ...curr };
                },
                { ...payload }
            );
        },
        getLocationPayloadByType(type) {
            switch (type) {
                case COORDINATES_CODE:
                    const coordinatesArr = this.coordinates.split(',');

                    return {
                        name: this.coordinatesName,
                        target_latitude: coordinatesArr[0],
                        target_longitude: coordinatesArr[1]
                    };
                case NEAREST_NIO_HOUSE_CODE:
                    // outlet_types 放到bff获取
                    return {};
                case NEAREST_CHARGING_PILE_CODE:
                    return {
                        resource_type: 'CS'
                    };
                case NEAREST_EXCHANGE_STATION_CODE:
                    return {
                        resource_type: 'PS'
                    };
                default:
                    return {};
            }
        },
        getDistanceDisplay(distance, fixed = 2) {
            if (distance === undefined) {
                return '--';
            }
            if (fixed === 'never') {
                return distance >= 1000
                    ? `${parseFloat(distance / 1000)}km`
                    : `${distance}m`;
            }
            return distance >= 1000
                ? `${(distance / 1000).toFixed(fixed)}km`
                : `${distance}m`;
        },
        refreshLocation() {
            this.getLocation();
            this.$emit('track', {
                is_clickable: true,
                button_name: '刷新'
            });
        },
        async getLocation() {
            try {
                this.isInitLocationPrivate = true;
                const res = await getLocation();
                await this.updateUserPosition(res);
            } catch (e) {
                console.error('Locate Failed: ', e);
                await this.updateUserPosition();
            } finally {
                this.isInitLocationPrivate = false;
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/views/marketing/mixin/award-location.js